import ConnectionCard from './connectionCard.view';

export default ConnectionCard;
